import React, { memo } from "react";
import { Handle, useStoreState, Position } from "react-flow-renderer";
import { EventTimer, RemaingTime } from "./styles.js";
import TimerNodeIcon from "../../../assets/icons/TimerNode.js";
import { DateTime } from 'luxon'
import { useRef } from "react";

function getTimeInDaysHoursMinutes(data) {

  if (data.status !== 'doing') {
    return null
  }

  const temporizationInHours = data.expiration.number;
  const start = DateTime.fromMillis(data.startedAt);
  const now = DateTime.now();

  const futureTime = start.plus({ hours: temporizationInHours });
  const diff = futureTime.diff(now, ['days', 'hours', 'minutes']);
  const { days, hours, minutes } = diff.toObject();

  let formattedOutput = '';
  if (days > 0) {
    formattedOutput += `${days}d ${hours}hrs restantes`;
  } else if (hours > 0) {
    formattedOutput += `${hours}h ${Math.round(minutes)}min restantes`;
  } else {
    formattedOutput += `${Math.round(minutes)}min restantes`;
  }

  return { stringify: formattedOutput, days, hours, minutes };
}


const TimerEventNode = ({
  data,
  id,
  targetPosition = Position.Left,
  sourcePosition = Position.Right,
  selected,
}) => {
  const edges = useStoreState((state) => state.edges);
  const nodes = useStoreState((state) => state.nodes);
  const anchorRef = useRef(null);

  const IconStyle = {
    width: "27px",
    height: "27px",
  };

  const HandleStyle = {
    width: "7px",
    height: "7px",
  };

  const timer = getTimeInDaysHoursMinutes(data)

  return (
    <>
      <EventTimer
        ref={anchorRef}
        className="flow_elements_node"
        data-id={id}
        status={data.status}
        selected={selected}
      >
        <TimerNodeIcon style={IconStyle} />

        <Handle
          type="source"
          position={sourcePosition}
          id="a"
          style={HandleStyle}
          isValidConnection={(e) =>
            nodes.find((item) => item.id === e.target).type === "parallelEnd" ||
              nodes.find((item) => item.id === e.target).type === "conditionalEnd"
              ? !edges.find((item) => item.source === e.source)
              : !edges.find(
                (item) => item.source === e.source || item.target === e.target
              )
          }
        />
        <Handle
          type="target"
          position={targetPosition}
          id="a"
          style={HandleStyle}
          isValidConnection={(e) =>
            nodes.find((item) => item.id === e.source).type === "parallel" ||
              nodes.find((item) => item.id === e.source).type === "conditional"
              ? true
              : !edges.find(
                (item) => item.target === e.target || item.source === e.source
              )
          }
        />

      </EventTimer>
      {data.status === "doing" ? (
        <RemaingTime>{timer.stringify}</RemaingTime>
      ) : null}
    </>
  );
};

export default memo(TimerEventNode);
